import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_11396_14667)">
          <path
            d="M8 10.6665H2.66667C2.48986 10.6665 2.32029 10.5963 2.19526 10.4712C2.07024 10.3462 2 10.1766 2 9.99984V3.33317C2 3.15636 2.07024 2.98679 2.19526 2.86177C2.32029 2.73674 2.48986 2.6665 2.66667 2.6665H13.3333C13.5101 2.6665 13.6797 2.73674 13.8047 2.86177C13.9298 2.98679 14 3.15636 14 3.33317V7.99984"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.6665 13.3335H7.99984"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 10.6665V13.3332"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.3335 12.6668C11.3335 13.0205 11.474 13.3596 11.724 13.6096C11.9741 13.8597 12.3132 14.0002 12.6668 14.0002C13.0205 14.0002 13.3596 13.8597 13.6096 13.6096C13.8597 13.3596 14.0002 13.0205 14.0002 12.6668C14.0002 12.3132 13.8597 11.9741 13.6096 11.724C13.3596 11.474 13.0205 11.3335 12.6668 11.3335C12.3132 11.3335 11.9741 11.474 11.724 11.724C11.474 11.9741 11.3335 12.3132 11.3335 12.6668Z"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.6665 10.3335V11.3335"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12.6665 14V15" stroke="#606F85" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M14.6888 11.5L13.8228 12"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5127 13.3335L10.646 13.8335"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.646 11.5L11.5127 12"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.8228 13.3335L14.6894 13.8335"
            stroke="#606F85"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_11396_14667">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
